import React, { useContext, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ReactComponent as ActionIcSearch24px } from '../../../../assets/icons/action/ic_search_24px.svg';
import { SelectCheckbox } from '../checkbox/checkbox';
import { SelectContext } from '../select-context';

/**
 * @typedef Props
 * @prop {{search: React.ReactNode}} [icons]
 */
/**
 * @param {Props} props
 */
const SelectSearch = ({ icons = {} }) => {
  const {
    id,
    multiple,
    searchPlaceholder,
    searchOption,
    handleChangeSearch,
    isOpen,
    hasSelectedAllOptions,
    handleClickSearchCheckbox,
    totalOptions,
    selectSearchRef
  } = useContext(SelectContext);

  useEffect(() => {
    if (isOpen) {
      selectSearchRef.current.focus();
    }
  }, [isOpen]);

  const classes = classNames({
    'motif-select-search': true,
    'motif-select-search-no-results': totalOptions === 0
  });

  return (
    <div className={classes}>
      {multiple && (
        <SelectCheckbox
          onClick={handleClickSearchCheckbox}
          selected={hasSelectedAllOptions.selected}
          indeterminate={hasSelectedAllOptions.indeterminate}
        />
      )}

      <input
        ref={selectSearchRef}
        className="motif-select-search-input"
        type="text"
        role="combobox"
        aria-autocomplete="list"
        aria-expanded={isOpen}
        aria-controls={`${id}-listbox`}
        placeholder={searchPlaceholder}
        value={searchOption}
        onChange={handleChangeSearch}
      />
      {icons.search || <ActionIcSearch24px className="motif-select-search-icon" />}
    </div>
  );
};

SelectSearch.propTypes = {
  icons: PropTypes.shape({
    search: PropTypes.node
  })
};

export { SelectSearch };
